import { adobeModalTrackEvent } from '../common/AdobeTagging/adobeModalTrackEvent';
import { Constants } from '../common/Constants';
import { getAmazonRoute } from './amazon.map.utils';

export const handleAWSMapClickLocation = async (
  map,
  selectedId,
  longitude,
  latitude,
  locationId,
  locationLng,
  locationLat,
  mapKey,
  mobileScreen,
  setDirections,
  setRouteEndCoords,
  setSelectedId,
  expandedListView = false
) => {
  if (selectedId === locationId && !mobileScreen) {
    return;
  }

  const lng = Number(longitude);
  const lat = Number(latitude);
  const locLng = Number(locationLng);
  const locLat = Number(locationLat);

  if (
    !Number.isFinite(lng) ||
    !Number.isFinite(lat) ||
    !Number.isFinite(locLng) ||
    !Number.isFinite(locLat)
  ) {
    return;
  }

  try {
    const routeDirections = await getAmazonRoute(
      map,
      lng,
      lat,
      locLng,
      locLat,
      'driving-traffic',
      0,
      mapKey
    );

    if (routeDirections) {
      setDirections(routeDirections);
    }
  } catch {
    // route fetch failed — continue so the selection and analytics still fire
  }

  setRouteEndCoords([locLng, locLat]);
  setSelectedId(locationId);

  if (expandedListView) {
    adobeModalTrackEvent(Constants.LIST_VIEW_NAVIGATION_MODAL);
  } else adobeModalTrackEvent(Constants.MAP_VIEW_NAVIGATION_MODAL);
};
